/* global axios */

import Cookies from 'js-cookie';
import endPoints from './endPoints';
import {
  clearCookiesOnLogout,
  deleteIndexedDBOnLogout,
} from '../store/utils/api';

export default {
  validityCheck() {
    const urlData = endPoints('validityCheck');
    return axios.get(urlData.url);
  },
  logout() {
    const urlData = endPoints('logout');
    const fetchPromise = new Promise((resolve, reject) => {
      if (window.axios) {
        // d99d (for 2fa screen logout)
        axios
          .delete(urlData.url)
          .then(response => {
            deleteIndexedDBOnLogout();
            clearCookiesOnLogout();
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      } else {
        // d99d
        deleteIndexedDBOnLogout();
        clearCookiesOnLogout();
        resolve();
      }
    });
    return fetchPromise;
  },
  hasAuthCookie() {
    return !!Cookies.getJSON('cw_d_session_info');
  },
  getAuthData() {
    if (this.hasAuthCookie()) {
      return Cookies.getJSON('cw_d_session_info');
    }
    return false;
  },
  // d99d why chatwoot removed it...
  resetPassword({ email }) {
    const urlData = endPoints('resetPassword');
    return axios.post(urlData.url, { email });
  },

  getQrCode() {
    const urlData = endPoints('qrCodeToConnect');
    return axios.get(urlData.url);
  },
  // .
  profileUpdate({
    password,
    password_confirmation,
    displayName,
    logo_user_url,
    avatar,
    messageSignatures = [],
    ...profileAttributes
  }) {
    const formData = new FormData();
    Object.keys(profileAttributes).forEach(key => {
      const hasValue = profileAttributes[key] === undefined;
      if (!hasValue) {
        formData.append(`profile[${key}]`, profileAttributes[key]);
      }
    });
    messageSignatures.forEach((value, idx) => {
      Object.keys(value).forEach(key => {
        const hasValue = value[key] === undefined;
        if (!hasValue) {
          formData.append(
            `profile[message_signatures_attributes][${idx}][${key}]`,
            value[key]
          );
        }
      });
    });
    formData.append('profile[display_name]', displayName || '');
    formData.append('profile[logo_user_url]', logo_user_url || '');

    if (password && password_confirmation) {
      formData.append('profile[password]', password);
      formData.append('profile[password_confirmation]', password_confirmation);
    }
    if (avatar) {
      formData.append('profile[avatar]', avatar);
    }
    return axios.put(endPoints('profileUpdate').url, formData);
  },

  changePassword({
    accountId,
    current_password,
    password,
    password_confirmation,
  }) {
    const formData = new FormData();
    if (current_password && password && password_confirmation) {
      formData.append('profile[current_password]', current_password);
      formData.append('profile[password]', password);
      formData.append('profile[password_confirmation]', password_confirmation);
    }

    const urlData = endPoints('changePassword');
    return axios.put(urlData.url(accountId), formData);
  },

  updateUISettings({ uiSettings }) {
    return axios.put(endPoints('profileUpdate').url, {
      profile: { ui_settings: uiSettings },
    });
  },

  updateAvailability(availabilityData) {
    return axios.post(endPoints('availabilityUpdate').url, {
      profile: { ...availabilityData },
    });
  },

  updateAutoOffline(accountId, autoOffline = false) {
    return axios.post(endPoints('autoOffline').url, {
      profile: { account_id: accountId, auto_offline: autoOffline },
    });
  },

  deleteAvatar() {
    return axios.delete(endPoints('deleteAvatar').url);
  },

  setActiveAccount({ accountId }) {
    const urlData = endPoints('setActiveAccount');
    return axios.put(urlData.url, {
      profile: {
        account_id: accountId,
      },
    });
  },
};
